import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import "./editBook.scss";
import Navbar from "../../components/navbar/Navbar";
import { CloudUpload } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Chip,
  styled,
  Paper,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  Autocomplete,
  InputLabel,
  Select,
} from "@mui/material";
import {
  deleteDoc,
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../../firebase";
import { generateKeywords } from "../../functions";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { handleInputNumber } from "../../context/commonFunctions";
import { useUserChats } from "../../context/ChatsContext";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function EditBook() {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const bookData = state && state.bookData;

  const { categories } = useUserChats();

  let dataValue;
  switch (state.type) {
    case "main":
      dataValue = {
        buttonMessage: "Update",
      };
      break;
    case "pending":
      dataValue = {
        buttonMessage: "Approve",
      };
      break;
    default:
      break;
  }

  const [radioTypeValue, setRadioTypeValue] = useState("book");
  const [radioPaymentValue, setRadioPaymentValue] = useState("paid");
  const [categoryArray, setCategoryArray] = useState([]);
  const [subCategoryArray, setSubCategoryArray] = useState([]);
  const [categoryVlaue, setCategoryValue] = useState("");
  const [subCategoryValue, setSubCategoryValue] = useState("");
  const [tagServerData, setTagServerData] = useState([]);
  const [tagData, setTagData] = useState([]);
  const [image, setImage] = useState(null);
  const [samplePdf, setSamplePdf] = useState(null);
  const [mainPdf, setMainPdf] = useState(null);
  const [formData, setFormData] = useState(bookData);
  const [formErrors, setFormErrors] = useState({
    name: "",
    about: "",
    author: "",
    publisher: "",
    discount: "",
    price: "",
    isbn: "",
    language: "",
    pdf_password: "",
    pages: "",
  });
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const [progress, setProgress] = useState(10);

  useEffect(() => {
    if (bookData.tags) {
      setTagData(bookData.tags);
    }
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    setCategoryArray(categories);
  }, [categories]);
  const validateForm = () => {
    const errors = {
      name: "",
      about: "",
      author: "",
      publisher: "",
      discount: "",
      price: "",
      isbn: "",
      language: "",
      pdf_password: "",
      pages: "",
    };

    let isValid = true;

    if (!formData.name.trim()) {
      errors.name = "Book Name cannot be empty";
      isValid = false;
    }
    if (!formData.about.trim()) {
      errors.about = "About cannot be empty";
      isValid = false;
    }
    if (!formData.author.trim()) {
      errors.author = "Author Name cannot be empty";
      isValid = false;
    }
    if (!formData.publisher.trim()) {
      errors.publisher = "Publisher Name cannot be empty";
      isValid = false;
    }
    if (formData.discount === "" || formData.discount === null || formData.discount === undefined) {
      errors.discount = "Discount cannot be empty";
      isValid = false;
    }
    if (!formData.price) {
      errors.price = "Price cannot be empty";
      isValid = false;
    }
    if (!formData.isbn.trim()) {
      errors.isbn = "ISBN No. cannot be empty";
      isValid = false;
    }
    if (!formData.language.trim()) {
      errors.language = "Language cannot be empty";
      isValid = false;
    }
    if (!formData.pdf_password.trim()) {
      errors.pdf_password = "PDF Password cannot be empty";
      isValid = false;
    }
    if (!formData.pages) {
      errors.pages = "PDF Pages cannot be empty";
      isValid = false;
    }
    let alertMessage = "Validation Error:\n";

    if (!categoryVlaue.trim()) {
      isValid = false;
      alertMessage += "- Category selection is required.\n";
    }
    if (!subCategoryValue.trim()) {
      isValid = false;
      alertMessage += "- Sub Category selection is required.\n";
    }
    if (tagData.length === 0) {
      isValid = false;
      alertMessage +=
        "- Please add at least one tag for better categorization.\n";
    }

    if (!isValid) {
      alert(alertMessage);
    }
    setFormErrors(errors);

    return isValid;
  };
  const handleSubmit = async (e) => {
    const nameSearchArray = generateKeywords(formData.name);
    const authorSearchArray = generateKeywords(formData.author);
    const publisherSearchArray = generateKeywords(formData.publisher);
    const categorySearchArray = generateKeywords(categoryVlaue);
    const subCategorySearchArray = generateKeywords(subCategoryValue);

    var tagsSearchArray = [];
    tagData.forEach(
      (tag) =>
        (tagsSearchArray = [...tagsSearchArray, ...generateKeywords(tag)])
    );
    // Validate the form before submitting
    if (validateForm()) {
      // Perform the form submission logic here
      var mapData = formData;
      mapData.searchKeywords = [
        ...nameSearchArray,
        ...authorSearchArray,
        ...publisherSearchArray,
        ...categorySearchArray,
        ...subCategorySearchArray,
        ...tagsSearchArray,
      ];
      // delete mapData["id"];
      delete mapData["publish_on"];
      mapData.tags = tagData;
      mapData.payment_type =
        radioPaymentValue.charAt(0).toUpperCase() + radioPaymentValue.slice(1);
      mapData.eType =
        radioTypeValue.charAt(0).toUpperCase() + radioTypeValue.slice(1);
      mapData.category = categoryVlaue;
      mapData.subCategory = subCategoryValue;
      setOpen(true);
      uploadDataToFirestore(mapData);
    } else {
      console.log("Form is not valid, do not submit");
    }
  };
  const uploadDataToFirestore = async (mapData) => {
    try {
      // Upload cover image
      if (image) {
        const coverImgRef = ref(
          storage,
          `files/${bookData.id}/cover_image.jpg`
        );
        const coverSnapshot = await uploadBytes(coverImgRef, image);
        const coverUrl = await getDownloadURL(coverSnapshot.ref);
        mapData.coverImage = coverUrl;
        mapData.thumbImage = coverUrl;
      }

      // Upload main PDF
      if (mainPdf) {
        const mainPDFRef = ref(
          storage,
          `files/${bookData.id}/${bookData.id}.pdf`
        );
        const mainSnapshot = await uploadBytes(mainPDFRef, mainPdf);
        mapData.pdfUrl = await getDownloadURL(mainSnapshot.ref);
      }

      // Upload sample PDF
      if (samplePdf) {
        const samplePDFRef = ref(
          storage,
          `files/${bookData.id}/sample_${bookData.id}.pdf`
        );
        const sampleSnapshot = await uploadBytes(samplePDFRef, samplePdf);
        mapData.samplePdfUrl = await getDownloadURL(sampleSnapshot.ref);
      }

      // Update Firestore document
      console.log(mapData);
      console.log(bookData.id);

      const bookref = doc(db, "eLibrary", bookData.id);
      if (state.type === "main") {
        await updateDoc(bookref, mapData);
      } else {
        // Ensure numeric fields have correct types for approval
        if (!mapData.unitSold) mapData.unitSold = 0;
        if (!mapData.rating) mapData.rating = 0.0;
        
        const bookrefTobeDeleted = doc(db, "pendingBooks", bookData.id);
        await deleteDoc(bookrefTobeDeleted);
        await setDoc(bookref, {
          ...mapData,
          publish_on: serverTimestamp(),
        });
      }

      setOpen(false);
      alert("Done");
      navigate(-1);
    } catch (error) {
      setOpen(false);
      alert("Error uploading document: " + error.message);
    }
  };

  const addTag = (newTag) => {
    if (!tagData.includes(newTag)) {
      setTagData((prevTags) => [...prevTags, newTag]);
    }
  };

  const handleSamplePDFChange = (e) => {
    const selectedPdf = e.target.files[0];

    if (selectedPdf && selectedPdf.type === "application/pdf") {
      setSamplePdf(selectedPdf);
    } else {
      alert("Please select a valid PDF file.");
    }
  };
  const handleMainPDFChange = (e) => {
    const selectedPdf = e.target.files[0];

    if (selectedPdf && selectedPdf.type === "application/pdf") {
      setMainPdf(selectedPdf);
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    // Check if the selected file is an image
    if (selectedImage && selectedImage.type.startsWith("image/")) {
      setImage(selectedImage);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const handleDeleteTag = (tagToRemove) => () => {
    setTagData((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };

  const handleRadioType = (event) => {
    setRadioTypeValue(event.target.value);
  };
  const handleRadioPaymentMode = (event) => {
    setRadioPaymentValue(event.target.value);
  };
  useEffect(() => {
    setRadioTypeValue(bookData.eType.toLowerCase());
    setRadioPaymentValue(bookData.payment_type.toLowerCase());
    setCategoryValue(bookData.category);

    // Find the category key that matches the book's category
    const categoryKey = Object.keys(categories).find(
      (key) => categories[key].title === bookData.category
    );

    if (categoryKey && bookData.subCategory) {
      const subCategoryArray = categories[categoryKey]?.subCategories || [];
      setSubCategoryValue(bookData.subCategory);
      setSubCategoryArray(subCategoryArray);
    }

    // Fetch data from Firestore
    const fetchData = async () => {
      try {
        const documentRef = doc(db, "Alphabet", "home");
        const snapshot = await getDoc(documentRef);
        const tags = snapshot.data().tags;
        setTagServerData(tags);
      } catch (error) {
        console.error("Error fetching data from Firestore:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="editBook">
      <Sidebar />
      <div className="editBookContainer">
        <Navbar />
        <div className="top">
          <h1>{"Edit Book"}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={
                image ? URL.createObjectURL(image) : "" + bookData.thumbImage
              }
              alt=""
            />
            <div className="formInput">
              <Button
                sx={{ marginTop: "10px" }}
                component="label"
                variant="outlined"
                startIcon={<CloudUpload />}
              >
                Select Image
                <VisuallyHiddenInput
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </Button>
            </div>
            <div className="formInput">
              <Typography sx={{ marginTop: "10px" }}>
                {samplePdf
                  ? "Selected Sample PDF  : " + samplePdf.name
                  : "Select a sample PDF file"}
              </Typography>
              <Button
                sx={{ marginTop: "10px" }}
                component="label"
                variant="outlined"
                startIcon={<CloudUpload />}
              >
                Choose file
                <VisuallyHiddenInput
                  type="file"
                  accept=".pdf*"
                  onChange={handleSamplePDFChange}
                />
              </Button>
            </div>
            <div className="formInput">
              <Typography sx={{ marginTop: "10px" }}>
                {mainPdf
                  ? "Selected PDF  : " + mainPdf.name
                  : "Select a PDF file"}
              </Typography>
              <Button
                sx={{ marginTop: "10px" }}
                component="label"
                variant="outlined"
                startIcon={<CloudUpload />}
              >
                Choose file
                <VisuallyHiddenInput
                  type="file"
                  accept=".pdf*"
                  onChange={handleMainPDFChange}
                />
              </Button>
            </div>
          </div>
          <div className="right">
            <div className="form">
              <div className="aboutInput" key={"name"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Book Name"
                  defaultValue={"" + bookData.name}
                  onChange={(e) => {
                    setFormData({ ...formData, name: e.target.value });
                  }}
                  error={formErrors.name !== ""}
                  helperText={formErrors.name}
                />
              </div>
              <div className="aboutInput" key={"about"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="About"
                  multiline
                  rows={4}
                  defaultValue={"" + bookData.about}
                  onChange={(e) => {
                    setFormData({ ...formData, about: e.target.value });
                  }}
                  error={formErrors.about !== ""}
                  helperText={formErrors.about}
                />
              </div>
              <div className="formInput" key={"auhtorName"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Author Name"
                  defaultValue={"" + bookData.author}
                  onChange={(e) => {
                    setFormData({ ...formData, author: e.target.value });
                  }}
                  error={formErrors.author !== ""}
                  helperText={formErrors.author}
                />
              </div>

              <div className="formInput" key={"publisherName"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Publisher Name"
                  defaultValue={"" + bookData.publisher}
                  onChange={(e) => {
                    setFormData({ ...formData, publisher: e.target.value });
                  }}
                  error={formErrors.publisher !== ""}
                  helperText={formErrors.publisher}
                />
              </div>
              <div className="formInput" key={"discount"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Discount"
                  onInput={handleInputNumber}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      discount: parseInt(e.target.value, 10) || 0,
                    });
                  }}
                  defaultValue={"" + bookData.discount}
                  error={formErrors.discount !== ""}
                  helperText={formErrors.discount}
                />
              </div>
              <div className="formInput" key={"price"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Price"
                  onInput={handleInputNumber}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      price: parseInt(e.target.value, 10) || 0,
                    });
                  }}
                  defaultValue={"" + bookData.price}
                  error={formErrors.price !== ""}
                  helperText={formErrors.price}
                />
              </div>
              <div className="formInput" key={"isbn"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="ISBN No."
                  defaultValue={"" + bookData.isbn}
                  onChange={(e) => {
                    setFormData({ ...formData, isbn: e.target.value });
                  }}
                  error={formErrors.isbn !== ""}
                  helperText={formErrors.isbn}
                />
              </div>
              <div className="formInput" key={"language"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Language"
                  defaultValue={"" + bookData.language}
                  onChange={(e) => {
                    setFormData({ ...formData, language: e.target.value });
                  }}
                  error={formErrors.language !== ""}
                  helperText={formErrors.language}
                />
              </div>

              <div className="formInput" key={"pdfPassword"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="PDF Password"
                  defaultValue={"" + bookData.pdf_password}
                  onChange={(e) => {
                    setFormData({ ...formData, pdf_password: e.target.value });
                  }}
                  error={formErrors.pdf_password !== ""}
                  helperText={formErrors.pdf_password}
                />
              </div>

              <div className="formInput" key={"category"}>
                <TextField
                  fullWidth
                  id="outlined-select-currency"
                  select
                  label="Category"
                  value={
                    Object.keys(categoryArray).find(
                      (key) => categoryArray[key]?.title === categoryVlaue
                    ) || ""
                  }
                  onChange={(e) => {
                    const selectedCategoryKey = e.target.value;
                    setCategoryValue(categoryArray[selectedCategoryKey].title);
                    setSubCategoryArray(
                      categories[selectedCategoryKey].subCategories || []
                    );
                    setSubCategoryValue(""); // Reset subcategory when category changes
                  }}
                >
                  {Object.keys(categoryArray).map((category) => (
                    <MenuItem key={category} value={category}>
                      {categoryArray[category].title}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              {subCategoryArray.length != 0 && (
                <div className="formInput" key={"subcategory"}>
                  <TextField
                    fullWidth
                    id="outlined-select-currency"
                    select
                    label="Sub Category"
                    value={subCategoryValue || ""}
                    onChange={(e) => {
                      setSubCategoryValue(e.target.value);
                    }}
                  >
                    {subCategoryArray.map((subCategory) => (
                      <MenuItem key={subCategory} value={subCategory}>
                        {subCategory}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              )}
              <div className="formInput" key={"tags"}>
                <InputLabel id="demo-simple-select-label">Tags</InputLabel>
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={""}
                  label="Tags"
                  onChange={(e) => {
                    const newTag = e.target.value;
                    addTag(newTag.toLowerCase());
                  }}
                >
                  {tagServerData.map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className="formInput" key={"pages"}>
                <TextField
                  fullWidth
                  onInput={handleInputNumber}
                  id="pages"
                  label="PDF Pages"
                  defaultValue={"" + bookData.pages}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      pages: parseInt(e.target.value, 10) || 0,
                    });
                  }}
                  error={formErrors.pages !== ""}
                  helperText={formErrors.pages}
                />
              </div>
              <Paper
                elevation={0}
                sx={{
                  width: "92%",
                  display: "flex",

                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {tagData.map((data) => {
                  let icon;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={data}
                        onDelete={handleDeleteTag(data)}
                      />
                    </ListItem>
                  );
                })}
              </Paper>
              <div className="formInput">
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group-type">
                    Type
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group-type"
                    value={radioTypeValue}
                    onChange={handleRadioType}
                  >
                    <FormControlLabel
                      value="book"
                      control={<Radio size="small" />}
                      label="Book"
                    />
                    <FormControlLabel
                      value="notes"
                      control={<Radio size="small" />}
                      label="Notes"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="formInput">
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    Payment Mode
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={radioPaymentValue}
                    onChange={handleRadioPaymentMode}
                  >
                    <FormControlLabel
                      value="paid"
                      control={<Radio size="small" />}
                      label="Paid"
                    />
                    <FormControlLabel
                      value="free"
                      control={<Radio size="small" />}
                      label="Free"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="formInput">
                <Button onClick={handleSubmit} fullWidth variant="contained">
                  {dataValue.buttonMessage}
                </Button>
              </div>

              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={open}
                onClick={handleClose}
              >
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <CircularProgress
                    color="inherit"
                    value={progress}
                    sx={{ marginBottom: "15px" }}
                  />
                  <Typography>Uploading image...</Typography>
                </Grid>
              </Backdrop>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditBook;
